export default "__VITE_ASSET__paqYqcR1__"